// src/store/checklistSavedSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ValuesMap = Record<string, any>

interface SavePayload {
  taskId: string | number
  values: ValuesMap
}

interface ChecklistSavedState {
  // keyed by taskId (stringified)
  saved: Record<string, ValuesMap>
}

const initialState: ChecklistSavedState = {
  saved: {},
}

const checklistSavedSlice = createSlice({
  name: 'checklistSaved',
  initialState,
  reducers: {
    savedChecklist(state, action: PayloadAction<SavePayload>) {
      const key = String(action.payload.taskId)
      state.saved[key] = action.payload.values
    },
  },
})

export const { savedChecklist } = checklistSavedSlice.actions
export default checklistSavedSlice.reducer

// selector helper (optional)
export const selectChecklistByTask = (state: any, taskId: string | number) =>
  state.checklistSaved?.saved?.[String(taskId)] ?? {}
